import { languageMap } from ".."

languageMap.ini = {
	comments: {
		line: ";",
	},
}
